import angular from "angular";

import ToolbarDirective from "./toolbar.directive";


/*@ngInject*/
const Toolbar = angular
    .module("app.toolbar",[])
    .directive('toolbarDirective',()=>ToolbarDirective)
    .name;

export default Toolbar;


// WEBPACK FOOTER //
// ./public/app/toolbar/index.js